<template>
  <v-container>
    <p>When an item with a <i>findmykit</i> smart tag is brought to you - all you need to do is simply scan the smart tag attached to the item using our free app.</p>

    <div class="d-flex flex-column flex-sm-row justify-center align-center" style="width: 100%">

      <div>
        <a href="https://play.google.com/store/apps/details?id=findmykitScanningApp.expo" target="_blank">
          <v-img
              :src="require('@/assets/google-play.png')"
              width="225"
              class="ma-1 ma-sm-6"
          >
          </v-img>
        </a>
      </div>
      <div>
        <a href="https://apps.apple.com/gb/app/id1527760767" target="_blank">
          <v-img
              :src="require('@/assets/ios-download-black.png')"
              width="200"
              class="ma-1 ma-sm-6"
          >
          </v-img>
        </a>
      </div>
    </div>

    <p>{{ $t("After you scan the item, the owner will be notified that an item of theirs has been found, and where they can collect it from") }}.</p>
    <p>{{ $t("All you have to do now is wait for the item to be collected, we cannot do anything about the items already in your lost property - but we can help to prevent the collection from growing!") }}</p>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "OrganisationsContent",
  computed: {
    ...mapState({
      brand: state => state.brand,
brandName: state => state.brandName
    }),
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  }
}
</script>

<style scoped>

</style>
